import CombatItemAttack from './CombatItemAttack';

export default CombatItemAttack;
export { CombatItemAttack };
